<template>
  <TitleLine :chinese="cardTitle" :showMore="showMore" :type="'thirdCard'">
    <component :is="pageComponent"></component>
  </TitleLine>
</template>

<script>
import mixinsBackStack from '@/views/backstageSupport/mixins'
import Edit from './edit.vue'
import Issue from './issue.vue'
import Detail from './detail.vue'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      pageComponent: 'Detail',
      cardTitle: '新增检索资源'
    }
  },
  components: {
    Edit,
    Issue,
    Detail
  },
  watch: {
    '$route.query': {
      handler() {
        this.switchComponent()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initTitleCard(name) {
      this.titleCard = name
    },
    // 组件切换
    switchComponent() {
      const { type } = this.$route.query
      switch (type) {
        case 'detail':
          this.pageComponent = 'Detail'
          this.cardTitle = '检索资源详情'
          break
        case 'edit':
          this.pageComponent = 'Edit'
          this.cardTitle = '编辑检索资源'
          break
        default:
          this.pageComponent = 'Issue'
          this.cardTitle = '新增检索资源'
          break
      }
    }
  }
}
</script>
